module.exports = "pegasus/assets/tech/safari/106.png";